import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { getRoutes } from 'utils/locale';
import { withVariables } from 'utils/string';

import LayoutContainer from 'components/layout/LayoutContainer';
import Pagination from 'components/layout/Pagination';
import MediumArticleBox from 'components/modules/public/layout/articles/MediumArticleBox';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageEmployerArticlesListSectionArticles: FunctionComponent<Props> = ({
    layoutContainerProps,
    articles,
    meta,
    iconsAlts,
}) => {
    const router = useRouter();
    const routes = getRoutes();

    return (
        <StyledComponent
            className="public-page-employer-articles-list-section-articles"
        >
            <LayoutContainer
                {...layoutContainerProps}
            >
                <div className="article-boxes">
                    {Array.isArray(articles) && articles.length > 0 && articles.map(element => (
                        <MediumArticleBox
                            key={element?.id}
                            article={element}
                            iconsAlts={iconsAlts}
                        />
                    ))}
                </div>
                <Pagination
                    currentPage={meta.currentPage}
                    lastPage={meta.lastPage}
                    onPageChange={(nextPage) => {
                        if(nextPage === meta.currentPage) {
                            return;
                        }

                        const path = withVariables(routes?.blogPage, { page: nextPage.toString() });
                        return router.push(path);
                    }}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageEmployerArticlesListSectionArticles;